<template>
  <v-dialog :value="value" width="800" @input="(v) => v || close()">
    <v-card>
      <v-card-title class="headline">
        発電所詳細
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="6">
            <table>
              <tr>
                <th>経産省ID</th>
                <td><strong>{{this.ministryId}}</strong></td>
              </tr>
              <tr>
                <th>発電所名</th>
                <td><strong>{{this.plantName}}</strong></td>
              </tr>
              <tr>
                <th>住所</th>
                <td><strong>{{this.plantAddress}}</strong></td>
              </tr>
              <tr>
                <th>DC容量</th>
                <td><strong>{{this.dc}}</strong></td>
              </tr>
              <tr>
                <th>AC容量</th>
                <td><strong>{{this.ac}}</strong></td>
              </tr>
            </table>
          </v-col>
          <v-col cols="6">
            <v-img
                lazy-src="../../assets/images/no-image.png"
                :src="this.plantThumbnail"
                :aspect-ratio="4 / 3"
            ></v-img>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions style="padding-right: 24px;">
        <v-spacer></v-spacer>
        <v-btn
          depressed
          @click="close()"
        >
          閉じる
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "PlantDetailDialog",
  props: ["value", "plant"],
  data() {
    return {
      ministryId: null,
      plantName: null,
      plantAddress: null,
      dc: null,
      ac: null,
      plantThumbnail: null,
    }
  },
  methods: {
    close(){
      this.$emit("input");
    }
  },
  watch: {
    plant: {
      handler(plant){
        this.ministryId = plant.plant.plant_id;
        this.plantName = plant.plant.plant_name;
        this.plantAddress = plant.plant.plant_address;
        if (plant.folder){
          this.plantThumbnail = plant.folder.thumbnail_color_path ? plant.folder.thumbnail_color_path : plant.folder.thumbnail_thermal_path;
        }
        else{
          this.plantThumbnail = require("../../assets/images/no-image.png");
        }
        this.dc = plant.main_plant.plant_dc;
        this.ac = plant.main_plant.plant_ac;
      }
    }
  }
}
</script>

<style scoped>
.v-dialog > .v-card > .v-card__text{
  padding-bottom: 0;
}
table{
  height: 100%;
  width:100%;
}
table, th, td {
  border: 1px solid black;
  border-collapse: collapse;
}
th, td {
  padding: 5px;
  text-align: center;
}
th {
  background-color: #BBDEFB;
  width: 40%;
}
</style>
